import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "flex-list"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import FlightWidget from "@/components/FlightWidget.vue";
import { ref } from "vue";
import { FlightModel } from "@/models/flight.model";
import { FlightService } from "@/services/flight.service";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const error = ref<string>()
const flights = ref<FlightModel[]>()

FlightService.getDepartures()
    .then(rsp => flights.value = rsp.data)
    .catch(e => error.value = e.message)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (flights.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flights.value, (f) => {
            return (_openBlock(), _createBlock(FlightWidget, {
              flight: f,
              key: f.id
            }, null, 8, ["flight"]))
          }), 128))
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Error: " + _toDisplayString(error.value), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Loading... Please wait!"))
  ]))
}
}

})